import { getCurrentUser } from 'nuxt-vuefire/runtime/auth/composables.js'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = await getCurrentUser()

  if (to.params.id === '1') {
    return abortNavigation()
  }

  if (user && !user.emailVerified && to.path !== '/confirm-email') {
    return navigateTo('/confirm-email')
  }

  const adminOnlyRoutes = ['/admin']
  if (adminOnlyRoutes.some((route) => to.path.startsWith(route))) {
    if (!user) {
      return navigateTo({
        name: 'signin',
        query: { redirect: to.fullPath },
      })
    } else {
      const token = await user.getIdTokenResult()
      const isAdmin = token.claims.role === 'admin'

      if (!isAdmin) {
        console.log('redirecting to /models')
        return navigateTo('/models')
      }
    }
  }
})
